import { ContactInitialStateType } from "../types/initialStateType";

export const contactInitialState: ContactInitialStateType = {
  contactsContainerId: undefined,
  contacts: undefined,
  // relatedEntityContactsIds: undefined,
};
